import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

// Img
import locationIcon from "../../../assets/svg/contact/ic-location.svg";
import clockIcon from "../../../assets/svg/ic-clock.svg";
import eventBanner1 from "../../../assets/png/banner-image.png";
import eventBanner2 from "../../../assets/png/event-banner.png";
import "./CreateNewEventForm.css";
import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputCheckbox,
  InputDate,
  InputDropdown,
  InputField,
  InputRadio,
  InputToggle,
  ListBlock,
  Text,
  Selectors,
  Notifications,
} from "@jds/core";

// Local
import CustomeTimePicker from "./customeTimePicker/CustomeTimePicker";
import EventBannerInput from "./eventBannerInput/EventBannerInput";
import useInput from "../../../hooks/use-input";
import {
  validateLink,
  validateNumberInput,
  validateTextInput,
} from "../../../util/validation";
import dayjs from "dayjs";
import useApiHttp from "../../../hooks/use-http";
import {
  addParamsURL,
  baseToImg,
  basetoFile,
  calculateDaysLeft,
  convertDateFormat,
  convertRailwayTimeToStandardTime,
  fileToBase,
  isValidDateRange,
  todayDate,
} from "../../../util/helper";
import { useDispatch, useSelector } from "react-redux";
import { eventListTrigger } from "../../../store/state-slices/apiTrigger";
import PageLoader from "../Loader/PageLoader";
import LocationInput from "./LocationInput";
import decryptUrl from "../../../util/img-decryption";
import DynamicForm from "../../DynamicFrom/DynamicForm";
import { Box, FormControlLabel, Stack, Switch } from "@mui/material";
import {
  setAccessModalClose,
  setAccessMsg,
  setActiveModalClose,
  setActiveMsg,
  setFreeTrialModalClose,
  setPlanModalClose,
  setSubscriptionPlan,
} from "../../../store/state-slices/plans";
import Loader from "../Loader/Loader";
import JdsModal from "../JdsModal";
import ImageGrid from "../../Layout/ImageGrid";

export default function CreateNewEventForm(props) {
  const {
    closeModal,
    close,
    dynamicFormHead,
    setDynamicFormHead,
    isJitoUser,
    vendorEventId,
  } = props;
  const dispatch = useDispatch();
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails,
  );
  const [eventTypeList, setEventTypeList] = useState([]);
  const [userStorage, setUserStorage] = useState({});
  const [eventList, setEventList] = useState({});
  const [defaultBanner, setDefaultBanner] = useState(null);
  const [eventImgDefault, setEventImgDefault] = useState(null);
  const [name, setName] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const [locationData, setLocationData] = useState({});
  const [dynamicForm, setDynamicForm] = useState(false);
  const [bannerImage, setBannerImage] = useState(null);
  const [isOpenEvent, setIsOpenEvent] = useState(true);
  const [defaultAccess, setDefaultAccess] = useState("FACE_ACCESS");
  const [defaultDownloadAccess, setDefaultDownloadAccess] =
    useState("APPROVED");
  const [defaultUploadAccess, setDefaultUploadAccess] = useState("APPROVED");
  const [showAdditional, setShowAdditional] = useState(true);
  const [expired, setExpired] = useState(false);
  const [expiredDate, setExpiredDate] = useState(false);
  const [storageDetails, setStorageDetails] = useState({});
  const [defaultDynamicField, setDefaultDynamicField] = useState([]);
  const [isWhielabelFielOpen, setIsWhitelabelFieldOpen] = useState(false);
  const [currentIndex, setCurrIndex] = useState(null);
  const [isEventTypeGalleryModalClose, setIsEventTypeGalleryModalClose] =
    useState(true);
  const [eventTypeImageId, setEventTypeImageId] = useState(null);

  const {
    value: enteredEventName,
    isValid: enteredEventNameIsValid,
    hasError: enteredEventNameHasError,
    valueChangeHandler: eventNameChangeHandler,
    inputBlurHandler: eventNameBlurHandler,
    reset: resetEventNameInput,
  } = useInput(validateTextInput);

  const {
    value: selectedEventType,
    isValid: selectedEventTypeIsValid,
    hasError: selectedEventTypeHasError,
    valueChangeHandler: eventTypeChangeHandler,
    inputBlurHandler: eventTypeBlurHandler,
    reset: resetEventTypeInput,
  } = useInput(validateTextInput);
  const {
    value: startDate,
    isValid: startDateIsValid,
    hasError: startDateHasError,
    valueChangeHandler: startDateChangeHandler,
    inputBlurHandler: startDateBlurHandler,
    reset: resetStartDateInput,
  } = useInput((dateStr) => {
    const regex = /^\d{4}[-/]\d{2}[-/]\d{2}$/;
    if (!regex.test(dateStr)) return false;
    const [yyyy, mm, dd] = dateStr?.replace(/-/g, "/")?.split("/").map(Number);
    if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
    const date = new Date(yyyy, mm - 1, dd);
    return (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    );
  });

  const {
    value: endDate,
    isValid: endDateIsValid,
    hasError: endDateHasError,
    valueChangeHandler: endDateChangeHandler,
    inputBlurHandler: endDateBlurHandler,
    reset: resetEndDateInput,
  } = useInput((dateStr) => {
    const regex = /^\d{4}[-/]\d{2}[-/]\d{2}$/;
    if (!regex.test(dateStr)) return false;
    const [yyyy, mm, dd] = dateStr?.replace(/-/g, "/")?.split("/").map(Number);
    if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;
    const date = new Date(yyyy, mm - 1, dd);
    return (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    );
  });
  const {
    value: location,
    isValid: locationIsValid,
    hasError: locationHasError,
    valueChangeHandler: locationChangeHandler,
    inputBlurHandler: locationBlurHandler,
    reset: resetLocationInput,
  } = useInput(validateTextInput);

  const {
    value: time,
    isValid: timeIsValid,
    hasError: timeHasError,
    valueChangeHandler: timeChangeHandler,
    inputBlurHandler: timeBlurHandler,
    reset: resetTimeInput,
  } = useInput((data) => {
    const date = new Date(data);
    if (Object.prototype.toString.call(date) === "[object Date]") {
      if (isNaN(date.getTime())) {
        return false;
      } else {
        return true;
      }
    }
  });

  const {
    value: bannerImg,
    isValid: bannerImgIsValid,
    hasError: bannerImgHasError,
    valueChangeHandler: bannerImgChangeHandler,
    inputBlurHandler: bannerImgBlurHandler,
    reset: resetBannerImgInput,
  } = useInput((data) => {
    return typeof data === "object" ? true : false;
  });

  const {
    value: preCost,
    isValid: preCostIsValid,
    hasError: preCostHasError,
    valueChangeHandler: preCostChangeHandler,
    inputBlurHandler: preCostBlurHandler,
    reset: resetPreCostInput,
  } = useInput(validateNumberInput, {
    type: "text",
    value: "0",
  });

  const {
    value: whiteLabelName,
    isValid: whiteLabelNameIsValid,
    hasError: whiteLabelNameHasError,
    valueChangeHandler: whiteLabelNameChangeHandler,
    inputBlurHandler: whiteLabelNameBlurHandler,
    reset: resetWhiteLabelNameInput,
  } = useInput(validateTextInput);

  const {
    value: packageName,
    isValid: packageNameIsValid,
    hasError: packageNameHasError,
    valueChangeHandler: packageNameChangeHandler,
    inputBlurHandler: packageNameBlurHandler,
    reset: resetPackageNameInput,
  } = useInput(validateTextInput);

  const {
    value: androidDeepLink,
    isValid: androidDeepLinkIsValid,
    hasError: androidDeepLinkHasError,
    valueChangeHandler: androidDeepLinkChangeHandler,
    inputBlurHandler: androidDeepLinkBlurHandler,
    reset: resetAndroidDeepLinkInput,
  } = useInput(validateLink);

  const {
    value: iosDeepLink,
    isValid: iosDeepLinkIsValid,
    hasError: iosDeepLinkHasError,
    valueChangeHandler: iosDeepLinkChangeHandler,
    inputBlurHandler: iosDeepLinkBlurHandler,
    reset: resetIosDeepLinkInput,
  } = useInput(validateLink);

  const { sendRequest: getEventTypeList, isLoading: eventListGeting } =
    useApiHttp();
  const { sendRequest: getUserStorage, isLoading: isStorageGetting } =
    useApiHttp();
  const { sendRequest: getEventList, isLoading: isEventGetting } = useApiHttp();

  const culumData = (data) => {
    setEventTypeList(data?.data?.results);
    if (profileDetailsRedux?.userType === "SCHOOL") {
      eventTypeChangeHandler({ target: { value: data?.data?.results[0]?.id } });

      const selectedEvent = data?.data?.results || [];
      const defaultBanner = selectedEvent[0]?.imageList[0]?.image;
      const defaultBannerId = selectedEvent[0]?.imageList[0]?.id;

      setEventTypeImageId(defaultBannerId);
      setDefaultBanner(decryptUrl(defaultBanner));
      setEventImgDefault(decryptUrl(defaultBanner));
      if (selectedEvent[0]?.name === "School") {
        setDefaultDynamicField([
          {
            id: uuidv4(),
            type: "text",
            questionName: "Parent Name",
            required: true,
          },
          {
            id: uuidv4(),
            type: "dropdown",
            questionName: "Grade",
            required: true,
            options: [
              "Nursery",
              "LKG",
              "UKG",
              "I",
              "II",
              "III",
              "IV",
              "V",
              "VI",
              "VII",
              "VIII",
              "IX",
              "X",
              "XI",
              "XII",
            ],
          },
          {
            id: uuidv4(),
            type: "text",
            questionName: "Roll Number",
            required: true,
          },
        ]);
      }
    }
    if (profileDetailsRedux?.userType === "JITO") {
      eventTypeChangeHandler({ target: { value: data?.data?.results[0]?.id } });

      const selectedEvent = data?.data?.results || [];
      const defaultBanner = selectedEvent[0]?.imageList[0]?.image;
      const defaultBannerId = selectedEvent[0]?.imageList[0]?.id;

      setEventTypeImageId(defaultBannerId);
      setDefaultBanner(decryptUrl(defaultBanner));
      setEventImgDefault(decryptUrl(defaultBanner));
    }
  };

  const { sendRequest: createEvent, isLoading: eventCreating } = useApiHttp();

  const chooseEventImgClickHandler = () => {
    if (!selectedEventType) {
      Notifications.toast.error({
        title: "Please select event type",
        id: "choose event image",
      });
      return;
    }
    const selectedEventTypeData = eventTypeList
      ?.find((val) => val.id === selectedEventType)
      ?.imageList.map((data) => ({
        thumbnailFileSignedPath: addParamsURL(decryptUrl(data?.image), {
          size: "s",
        }),
      }));
    console.log(selectedEventType);
    console.log(selectedEventTypeData);
    setIsEventTypeGalleryModalClose(false);
  };

  const eventBannerGalleryModalCloseHandler = () => {
    setIsEventTypeGalleryModalClose(true);
    setCurrIndex(null);
  };

  function isValidYYYYMMDD(dateStr) {
    const regex = /^\d{4}\/\d{2}\/\d{2}$/;
    if (!regex.test(dateStr)) return false;

    const [yyyy, mm, dd] = dateStr.split("/").map(Number);

    if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return false;

    const date = new Date(yyyy, mm - 1, dd);

    return (
      date.getFullYear() === yyyy &&
      date.getMonth() === mm - 1 &&
      date.getDate() === dd
    );
  }

  const handleCreateEvent = (dynamicField) => {
    const eventTypeLabel = eventTypeList.filter(
      (item) => item.id === selectedEventType,
    )[0]?.name;
    let formatTime = dayjs(time).format("HH:mm:ss");
    const formData = new FormData();
    formData.append("locationLongitude", locationData?.lng);
    formData.append("locationLatitude", locationData?.lat);
    formData.append("eventType", selectedEventType);
    formData.append("eventTypeName", eventTypeLabel);
    formData.append("name", enteredEventName);
    formData.append("startDate", convertDateFormat(startDate));
    formData.append("endDate", convertDateFormat(endDate));
    formData.append("locationName", locationData?.name || location);
    formData.append("locationState", locationData?.state || "");
    formData.append("isAutoApproval", isOpenEvent);
    formData.append("defaultAccess", defaultAccess);
    formData.append("defaultDownloadAccess", defaultDownloadAccess);
    formData.append(
      "defaultUploadAccess",
      isJitoUser ? "REJECTED" : defaultUploadAccess,
    );
    formData.append("premiumImageCost", preCost);
    eventTypeImageId && formData.append("eventTypeImageId", eventTypeImageId);
    if (vendorEventId && vendorEventId !== "null") {
      console.log("vendorEventId===", vendorEventId);
      formData.append("vendorEventId", vendorEventId);
    }

    formData.append(
      "time",
      startDate === endDate
        ? convertRailwayTimeToStandardTime(formatTime)
        : null,
    );
    formData.append("bannerimage", bannerImg || null);
    formData.append("customField", JSON.stringify(dynamicField));
    if (isWhielabelFielOpen) {
      formData.append("whiteLabelName", whiteLabelName);
      formData.append("packageName", packageName);
      formData.append("androidDeepLink", androidDeepLink);
      formData.append("iosDeepLink", iosDeepLink);
    }
    createEvent(
      {
        url: "event/create_event",
        method: "POST",
        body: formData,
        formData: true,
      },
      null,
      (data) => {
        if (data?.statusCode === 201) {
          if (isNewUser) {
            closeModal();
            dispatch(eventListTrigger());
            dispatch(setFreeTrialModalClose(false));
            if (
              !storageDetails?.planActive ||
              storageDetails?.freeTrialPlanActive
            ) {
              dispatch(setSubscriptionPlan(true));
            } else {
              dispatch(setSubscriptionPlan(false));
            }
          } else {
            props?.setSuccessModal(false);
            props?.setEventId(data?.data?.id);
            closeModal();
            dispatch(eventListTrigger());
          }
        }
      },
      (err, data) => {
        if (data?.statusCode == 402) {
          dispatch(setActiveModalClose(false));
          dispatch(setActiveMsg(data?.errors?.planType));
          closeModal();
        } else {
          Notifications.toast.error({
            title: data?.message,
            id: "create-event",
          });
        }
      },
    );
  };

  const formSubmitHandler = async (e) => {
    eventTypeBlurHandler(enteredEventName);
    eventNameBlurHandler(selectedEventType);
    startDateBlurHandler(startDate);
    endDateBlurHandler(endDate);
    locationBlurHandler(location);
    timeBlurHandler(time);
    preCostBlurHandler(preCost);
    if (!defaultBanner) {
      bannerImgBlurHandler(bannerImg);
    }
    whiteLabelNameBlurHandler(whiteLabelName);
    packageNameBlurHandler(packageName);
    androidDeepLinkBlurHandler(androidDeepLink);
    iosDeepLinkBlurHandler(iosDeepLink);
    let whiteLabelValid = true;
    if (isWhielabelFielOpen) {
      whiteLabelValid =
        whiteLabelNameIsValid &&
        packageNameIsValid &&
        androidDeepLinkIsValid &&
        iosDeepLinkIsValid;
    }
    const dateCheck = startDate === endDate ? timeIsValid : true;
    console.log(
      "hello123",
      selectedEventTypeIsValid &&
        startDateIsValid &&
        endDateIsValid &&
        locationIsValid &&
        preCostIsValid &&
        locationData?.name &&
        locationData?.lat &&
        locationData?.lng &&
        dateCheck &&
        whiteLabelValid,
    );

    if (
      selectedEventTypeIsValid &&
      enteredEventNameIsValid &&
      startDateIsValid &&
      endDateIsValid &&
      locationIsValid &&
      preCostIsValid &&
      locationData?.name &&
      locationData?.lat &&
      locationData?.lng &&
      dateCheck &&
      whiteLabelValid &&
      !isJitoUser
    ) {
      setDynamicForm(true);
      props?.setDynamicFormHead(true);
    } else {
      // handleCreateEvent(null);
    }
  };

  useEffect(() => {
    getEventTypeList(
      {
        url: `event-types/get-all`,
        method: "GET",
      },
      culumData,
    );
    props?.setDynamicFormHead(false);

    // getUserStorage(
    //   {
    //     url: `storage/user`,
    //     method: "GET",
    //     base: "MEDIA",
    //   },
    //   null,
    //   (data) => {
    //     setStorageDetails({
    //       ...data?.data,
    //     });
    //     if (data?.data?.planType === "FREE_TRIAL") {
    //       let date = calculateDaysLeft(data?.data?.expiryDate);
    //       dispatch(
    //         setAccessMsg(
    //           `${date} days left in your trial. Upgrade now to keep your storage hassle-free.`
    //         )
    //       );
    //       dispatch(setAccessModalClose(false));
    //       closeModal();
    //     }

    //     if (data?.data?.planType === "FREE_TRIAL_AVAILABLE") {
    //       setIsNewUser(true);
    //     }
    //     let date = calculateDaysLeft(data?.data?.expiryDate);
    //     if (date <= 10 && date >= 0) {
    //       setExpired(true);
    //       setExpiredDate(date);
    //       props?.setExpired && props?.setExpired(true);
    //     }
    //     if (
    //       !data?.data?.freeTrialPlanActive &&
    //       !data?.data?.planActive &&
    //       data?.data?.planType !== "FREE_TRIAL_AVAILABLE"
    //     ) {
    //       dispatch(
    //         setAccessMsg(
    //           "Your trial/ subscription has ended. Upgrade now to regain full access to your photos and storage"
    //         )
    //       );
    //       dispatch(setAccessModalClose(false));
    //       closeModal();
    //     }
    //   },
    //   (err, data) => {
    //     if (data?.statusCode != 404) {
    //       Notifications.toast.error({
    //         id: "user-storage",
    //         title: data.message,
    //       });
    //     }
    //   }
    // );
  }, []);

  useEffect(() => {
    if (!close) {
      setName("");
    }
    resetEventNameInput();
    resetTimeInput();
  }, [close]);

  if (eventListGeting || isStorageGetting || isEventGetting) {
    return (
      <div
        style={{
          height: "30em",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>
          <Loader size="large" />
        </div>
      </div>
    );
  }
  // if (userStorage?.freeTrialPlanActive && eventList?.count !== 0) {
  //   return (
  //     <p>
  //       Your trial/ subscription has ended. Upgrade now to regain full access to
  //       your photos and storage
  //     </p>
  //   );
  // }
  // if (expired) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         flexDirection: "column",
  //         gap: "16px",
  //       }}
  //     >
  //       <Text
  //         text={`Your subscription will expire soon.`}
  //         appearance="heading_xs"
  //         color="feedback_error_50"
  //       />
  //       <Text
  //         text={`${expiredDate > 0 ? expiredDate + " Day(s)" : "Today"
  //           }  Left! Keep Your Memories Safe – Choose a Plan Today!`}
  //         appearance="body_s"
  //       />
  //       <Container
  //         fullWidth
  //         direction="row"
  //         gap={24}
  //         style={{ marginTop: "16px" }}
  //       >
  //         <Button
  //           fullWidth
  //           kind="secondary"
  //           label="Create Event"
  //           onClick={() => {
  //             setExpired(false);
  //             setExpiredDate(false);
  //             props?.setExpired && props?.setExpired(false);
  //           }}
  //         />
  //         <Button
  //           fullWidth
  //           label="Choose Plan"
  //           onClick={() => {
  //             closeModal();
  //             dispatch(setPlanModalClose(false));
  //             if (
  //               !storageDetails?.planActive ||
  //               storageDetails?.freeTrialPlanActive
  //             ) {
  //               dispatch(setSubscriptionPlan(true));
  //             } else {
  //               dispatch(setSubscriptionPlan(false));
  //             }
  //           }}
  //         />
  //       </Container>
  //     </div>
  //   );
  // }
  return (
    <>
      {!dynamicForm ? (
        <form
          action=""
          className="column-form fullwidth"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          {/* <Box>
            <Container
              fullWidth
              horizontalAlign="space-between"
              verticalAlign="center"
            >
              <Text
                text={`Do you have white-labeled application?`}
                appearance="body-m"
              />
              <FormControlLabel
                // checked={isAutoApproval}
                control={<Switch checked={isWhielabelFielOpen} />}
                label={<Text text="" color="primary_grey_80" />}
                labelPlacement="start"
                onChange={() => setIsWhitelabelFieldOpen((pre) => !pre)}
              />
            </Container>
            {isWhielabelFielOpen && (
              <Stack direction="column" gap={2} mb={2}>
                <InputField
                  label="White Label Name*"
                  value={whiteLabelName}
                  onChange={whiteLabelNameChangeHandler}
                  // onBlur={eventNameBlurHandler}
                  state={whiteLabelNameHasError ? "error" : "none"}
                  stateConfig={{
                    errorText: "Please enter a label name!",
                  }}
                />
                <InputField
                  label="Application key*"
                  value={packageName}
                  onChange={packageNameChangeHandler}
                  // onBlur={eventNameBlurHandler}
                  state={packageNameHasError ? "error" : "none"}
                  stateConfig={{
                    errorText: "Please enter a application key!",
                  }}
                />
                <InputField
                  label="Playstore URL*"
                  value={androidDeepLink}
                  onChange={androidDeepLinkChangeHandler}
                  // onBlur={eventNameBlurHandler}
                  state={androidDeepLinkHasError ? "error" : "none"}
                  stateConfig={{
                    errorText: "Please enter a URL!",
                  }}
                />
                <InputField
                  label="Appstore URL*"
                  value={iosDeepLink}
                  onChange={iosDeepLinkChangeHandler}
                  // onBlur={eventNameBlurHandler}
                  state={iosDeepLinkHasError ? "error" : "none"}
                  stateConfig={{
                    errorText: "Please enter a URL!",
                  }}
                />
              </Stack>
            )}
          </Box> */}

          <Text text="Event Banner" appearance="body-m" />
          <EventBannerInput
            initialValue={bannerImage}
            fileValue={(value) => {
              bannerImgChangeHandler({ target: { value } });
              setBannerImage(value);
              // fileToBase(value)
              //   .then((base64Value) => {
              //     bannerImgChangeHandler({ target: { value: base64Value } });
              //   })
              //   .catch((error) => {
              //
              //   });
              setEventTypeImageId(null);
            }}
            errorText={bannerImgHasError ? "Please select the image" : ""}
            defaultBanner={bannerImage ? null : defaultBanner}
            chooseEventImgClickHandler={() => chooseEventImgClickHandler()}
            selectedEventType={selectedEventType}
            disableBannerCTA={isJitoUser}
            // defaultBanner={defaultBanner}
          />
          {/* {selectedEventType && <Box>
            <Button label="Choose image" onClick={() => {
              const selectedEventTypeData = eventTypeList?.find(val => val.id === selectedEventType)
                ?.imageList.map(data => (
                  {
                    thumbnailFileSignedPath: addParamsURL(decryptUrl(data?.image), {
                      size: "s",
                    })
                  }
                ))
              console.log(selectedEventType)
              console.log(selectedEventTypeData)
              setIsEventTypeGalleryModalClose(false)
            }} />
          </Box>} */}
          <InputDropdown
            label="Select Event Category"
            disabled={
              profileDetailsRedux?.userType === "SCHOOL" ||
              profileDetailsRedux?.userType === "JITO"
                ? true
                : false
            }
            value={selectedEventType}
            items={eventTypeList?.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            })}
            onSelect={(index, value) => {
              eventTypeChangeHandler({ target: { value: value } });

              const selectedEvent =
                eventTypeList?.filter((item, index) => {
                  return item.id === value;
                }) || [];
              const defaultBanner = selectedEvent[0]?.imageList[0]?.image;
              const defaultBannerId = selectedEvent[0]?.imageList[0]?.id;

              setEventTypeImageId(defaultBannerId);
              setDefaultBanner(decryptUrl(defaultBanner));
              setEventImgDefault(decryptUrl(defaultBanner));
              if (selectedEvent[0]?.name === "School") {
                setDefaultDynamicField([
                  {
                    id: uuidv4(),
                    type: "text",
                    questionName: "Parent Name",
                    required: true,
                  },
                  {
                    id: uuidv4(),
                    type: "dropdown",
                    questionName: "Grade",
                    required: true,
                    options: [
                      "Nursery",
                      "LKG",
                      "UKG",
                      "I",
                      "II",
                      "III",
                      "IV",
                      "V",
                      "VI",
                      "VII",
                      "VIII",
                      "IX",
                      "X",
                      "XI",
                      "XII",
                    ],
                  },
                  {
                    id: uuidv4(),
                    type: "text",
                    questionName: "Roll Number",
                    required: true,
                  },
                ]);
              }
            }}
            // onClose={eventTypeBlurHandler}
            state={selectedEventTypeHasError ? "error" : "none"}
            stateConfig={{ errorText: "Please select the event type" }}
          />

          <InputField
            label="Event Name"
            value={enteredEventName}
            onChange={eventNameChangeHandler}
            // onBlur={eventNameBlurHandler}
            state={enteredEventNameHasError ? "error" : "none"}
            stateConfig={{ errorText: "Please enter a valid event name!" }}
          />

          {/* <InputField
        label="test"
        onChange={(e) => {
          setName(e.target.value);
        }}
        value={name}
      /> */}
          <InputDate
            label="Event start date"
            name="start-date"
            datePicker={true}
            value={""}
            onChange={(value) => {
              if (isValidYYYYMMDD(value)) {
                if (!isValidDateRange(value, endDate) && endDate) {
                  endDateChangeHandler({ target: { value: "" } });
                  Notifications.toast.error({
                    title: "End date cannot be earlier than the start date.",
                    id: "event_end_date",
                  });
                }
                startDateChangeHandler({ target: { value } });
              } else {
                startDateChangeHandler({ target: { value: "" } });
              }
            }}
            // min={todayDate()}
            error={startDateHasError}
            errorText="Please enter the valid date"
            // value={startDate}
          />
          <InputDate
            label="Event end date"
            // helperText="Helper text"
            name="end-date"
            value={endDate}
            datePicker={true}
            onChange={(value) => {
              if (isValidYYYYMMDD(value)) {
                endDateChangeHandler({ target: { value } });
              } else {
                endDateChangeHandler({ target: { value: "" } });
              }
            }}
            error={endDateHasError}
            errorText="Please enter the valid date"
            min={startDate}
          />

          {startDate === endDate && (
            <CustomeTimePicker
              label="Event Time"
              placeholder=""
              slotProps={{
                textField: {
                  variant: "standard",
                },
                inputAdornment: {
                  sx: {
                    marginRight: "15px",
                    marginBottom: "10px",
                  },
                },
              }}
              slots={{
                openPickerIcon: () => (
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12H7C6.73479 12 6.48043 11.8946 6.2929 11.7071C6.10536 11.5196 6 11.2652 6 11C6 10.7348 6.10536 10.4804 6.2929 10.2929C6.48043 10.1054 6.73479 10 7 10H9V7C9 6.73478 9.10536 6.48043 9.2929 6.29289C9.48043 6.10536 9.73479 6 10 6C10.2652 6 10.5196 6.10536 10.7071 6.29289C10.8946 6.48043 11 6.73478 11 7V11Z"
                      fill="var(--color-primary-60)"
                    />
                  </svg>
                ),
              }}
              onChange={(value) => {
                timeChangeHandler({ target: { value } });
              }}
              errorMsg={timeHasError ? " Please selcet the time" : ""}
              value={time || null}
            />
          )}
          {/* <InputField
          label="Event Location"
          value={location}
          onChange={locationChangeHandler}
          state={locationHasError ? "error" : "none"}
          stateConfig={{ errorText: "Please enter a valid event name!" }}
          suffix={<Icon ic={<img src={locationIcon} alt="location icon" />} />}
        /> */}

          <LocationInput
            value={location}
            onChange={(value) => {
              locationChangeHandler(value);
            }}
            state={locationHasError ? "error" : "none"}
            stateConfig={{ errorText: "Please enter a valid location!" }}
            onLocationSelect={(data) => {
              setLocationData(data);
              locationChangeHandler({ target: { value: data?.name } });

              // locationChangeHandler(data.name);
            }}
            // value={locationData.name}
          />
          {/* <InputField
            label="Premium Image Cost"
            value={preCost}
            onChange={preCostChangeHandler}
            state={preCostHasError ? "error" : "none"}
            stateConfig={{ errorText: "Please enter a valid cost!" }}
          /> */}

          {/* <div
            onClick={() => setShowAdditional(!showAdditional)}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "end",
            }}
          >
            <Text
              text="Show additional settings"
              appearance="body_s_bold"
              color="primary_60"
            />
            <Icon
              ic={showAdditional ? "IcChevronUp" : "IcChevronDown"}
              color="primary_60"
            />
          </div> */}

          <div
          // style={{
          //   maxHeight: showAdditional ? "300px" : "0",
          //   opacity: showAdditional ? 1 : 0,
          //   overflow: "scroll",
          //   transition: "max-height 0.5s ease-in-out, opacity 1s ease-in-out",
          // }}
          >
            {showAdditional && !isJitoUser && (
              <div>
                {/* <Container
                  direction="column"
                  gap={24}
                  style={{ marginTop: "12px" }}
                >
                  <Container gap={24}>
                    <InputRadio
                      checked={defaultAccess === "FACE_ACCESS"}
                      label="Face Access"
                      value="FACE_ACCESS"
                      size="small"
                      onClick={(e) => setDefaultAccess(e.target.value)}
                    />
                    <InputRadio
                      checked={defaultAccess === "FULL_ACCESS"}
                      label="Full Access"
                      value="FULL_ACCESS"
                      size="small"
                      onClick={(e) => setDefaultAccess(e.target.value)}
                    />
                  </Container>
                  <InputCheckbox
                    label="Download Access"
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setDefaultDownloadAccess(
                        checked ? "APPROVED" : "REJECTED"
                      );
                    }}
                  />
                  <Box
                    sx={{
                      "& .j-JDSToggle-horizontal-container": {
                        marginLeft: "-10px",
                      },
                    }}
                  >
                    <InputToggle
                      label="Open Event"
                      labelPosition="right"
                      onChange={(e) => setIsOpenEvent(e.target.checked)}
                    />
                  </Box>
                </Container> */}

                <Box
                  sx={{
                    padding: "16px 0",
                    borderBottom: "1px solid var(--color-primary-grey-60)",
                  }}
                >
                  {/* <div className="box-container"></div> */}
                  <Box mb={1}>
                    <Text text="Photos Access" appearance="body_s_bold" />
                    <Text
                      text={
                        defaultAccess === "FULL_ACCESS"
                          ? "Guests can view all photos from the Event."
                          : "Guests can view their photos from the Event."
                      }
                      appearance="body_xs_bold"
                      color="primary_grey_60"
                    />
                  </Box>
                  <div style={{ width: "60%" }}>
                    <Selectors
                      stretch={true}
                      selectedIndex={defaultAccess === "FULL_ACCESS" ? 1 : 0}
                      items={[
                        { label: "Face Access", value: "FACE_ACCESS" },
                        { label: "Full Access", value: "FULL_ACCESS" },
                      ]}
                      onChange={(value) => {
                        setDefaultAccess(value);
                      }}
                    />
                  </div>
                </Box>

                <Box
                  sx={{
                    padding: "16px 0",
                    borderBottom: "1px solid var(--color-primary-grey-60)",
                  }}
                >
                  {/* <div className="box-container"></div> */}
                  <Box mb={1}>
                    <Text text="Upload Access" appearance="body_s_bold" />
                    <Text
                      text={
                        defaultUploadAccess === "APPROVED"
                          ? "All guests can upload event  photos."
                          : "You can choose which guests can upload the photos."
                      }
                      appearance="body_xs_bold"
                      color="primary_grey_60"
                    />
                  </Box>
                  <div style={{ width: "60%" }}>
                    <Selectors
                      selectedIndex={defaultUploadAccess === "APPROVED" ? 0 : 1}
                      stretch={true}
                      items={[
                        { label: "Yes", value: "APPROVED" },
                        { label: "No", value: "REJECTED" },
                      ]}
                      onChange={(value) => {
                        setDefaultUploadAccess(value);
                      }}
                    />
                  </div>
                </Box>
                <Box
                  sx={{
                    padding: "16px 0",
                    borderBottom: "1px solid var(--color-primary-grey-60)",
                  }}
                >
                  {/* <div className="box-container"></div> */}
                  <Box mb={1}>
                    <Text text="Download Access" appearance="body_s_bold" />
                    <Text
                      text={
                        defaultDownloadAccess === "APPROVED"
                          ? "All guests can download event photos."
                          : "You can choose which guests can download the photos."
                      }
                      appearance="body_xs_bold"
                      color="primary_grey_60"
                    />
                  </Box>
                  <div style={{ width: "60%" }}>
                    <Selectors
                      selectedIndex={
                        defaultDownloadAccess === "APPROVED" ? 0 : 1
                      }
                      stretch={true}
                      items={[
                        { label: "Yes", value: "APPROVED" },
                        { label: "No", value: "REJECTED" },
                      ]}
                      onChange={(value) => {
                        setDefaultDownloadAccess(value);
                      }}
                    />
                  </div>
                </Box>

                <Box sx={{ padding: "16px 0" }}>
                  {/* <div className="box-container"></div> */}
                  <Box mb={1}>
                    <Text text="Event type" appearance="body_s_bold" />
                    <Text
                      text={
                        isOpenEvent
                          ? "Guests scanning the QR code can join the event automatically."
                          : "Guests scanning the QR code need your approval to join the event."
                      }
                      appearance="body_xs_bold"
                      color="primary_grey_60"
                    />
                  </Box>
                  <div style={{ width: "60%" }}>
                    <Selectors
                      selectedIndex={isOpenEvent ? 0 : 1}
                      stretch={true}
                      items={[
                        { label: "Public", value: "0" },
                        { label: "Private", value: "1" },
                      ]}
                      onChange={(value) => {
                        setIsOpenEvent(value === "0" ? true : false);
                      }}
                      sx={{ marginLeft: 0 }}
                    />
                  </div>
                </Box>
              </div>
            )}
          </div>

          <Container
            fullWidth
            horizontalAlign="center"
            style={{ marginTop: "16px" }}
          >
            <ActionButton
              size="large"
              label={isJitoUser ? "Create Photoshare" : "Next"}
              onClick={() => {
                formSubmitHandler();
              }}
              state={eventCreating ? "loading" : "default"}
            />
          </Container>
        </form>
      ) : (
        <DynamicForm
          setDynamicField={(val) => {
            handleCreateEvent(val);
          }}
          setDefaultDynamicField={setDefaultDynamicField}
          dynamicForm={dynamicForm}
          setDynamicForm={setDynamicForm}
          dynamicFormHead
          setDynamicFormHead={setDynamicFormHead}
          defaultDynamicField={defaultDynamicField}
          disabled={eventCreating}
        />
      )}
      <JdsModal
        size="m"
        // header="Event Banner"
        kind="dialog"
        primaryCTA={{
          title: "Next",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isEventTypeGalleryModalClose}
        onClose={() => {
          eventBannerGalleryModalCloseHandler();
        }}
        onPrimaryClick={() => {
          eventBannerGalleryModalCloseHandler();
        }}
        onSecondaryClick={() => {
          eventBannerGalleryModalCloseHandler();
        }}
        primaryCtaDisabled={currentIndex == null}
      >
        <Container direction="column" fullWidth>
          <Box direction="column">
            <Text text="Choose event banner" appearance="heading-xs" />
            {/* <Text text="Choose an image for the event banner" appearance="body-s" color="primary-grey-80" /> */}
          </Box>
          {!isEventTypeGalleryModalClose && (
            <Box sx={{ width: "100%" }} mt={2} p={0.5}>
              <ImageGrid
                emptyGrid={selectedEventType ? false : true}
                images={eventTypeList
                  ?.find((val) => val.id === selectedEventType)
                  ?.imageList.map((data) => ({
                    thumbnailFileSignedPath: data?.image,
                  }))}
                setCurrIndex={(index) => {
                  setCurrIndex(index);
                  const eventTypeImgList = eventTypeList?.find(
                    (val) => val.id === selectedEventType,
                  )?.imageList;
                  setEventTypeImageId(eventTypeImgList[index]?.id);
                  setDefaultBanner(decryptUrl(eventTypeImgList[index]?.image));
                  // setEventImgDefault(decryptUrl(eventTypeImgList[index]?.image));
                }}
                currentIndex={currentIndex}
                selectImg={true}
                param={false}
              />
            </Box>
          )}
        </Container>
      </JdsModal>
    </>
  );
}
